import { Type, TokenWrapperType } from './types.mjs';
import { createElement } from '../../../../core/utilities/nodes/elements/createElement.mjs';
import { isElement } from '../../../../core/utilities/nodes/elements/isElement.mjs';

const ZERO_WIDTH_SPACE = '\u200B';
function createTokenElement(data, marks) {
  return createElement(Type, data, [{
    ...marks,
    text: ''
  }]);
}
function createTokenWrapperElement(children) {
  return createElement(TokenWrapperType, {}, children);
}
function isTokenElement(node) {
  return isElement(node) && node.type === Type;
}
function isBlockTokenElement(node) {
  return isTokenElement(node) && Boolean(node.block);
}
function isInlineTokenElement(node) {
  return isTokenElement(node) && !node.block;
}
function isTokenWrapperElement(node) {
  return isElement(node) && node.type === TokenWrapperType;
}
function isDefaultBlockTypeElement(node, defaultType) {
  return isElement(node) && node.type === defaultType;
}

export { ZERO_WIDTH_SPACE, createTokenElement, createTokenWrapperElement, isBlockTokenElement, isDefaultBlockTypeElement, isInlineTokenElement, isTokenElement, isTokenWrapperElement };
